import Cookies from 'js-cookie'

const channelTokenkey = 'channel'
// const sourceTokenkey = 'source'
const userIdTokenkey = 'userId'

export function getToken (TokenKey) {
  if (TokenKey === channelTokenkey) {
    return getChannel()
  }
  return Cookies.get(TokenKey)
}

export function setToken (TokenKey, token) {
  if (TokenKey === channelTokenkey) {
    return setChannel(token)
  }
  return Cookies.set(TokenKey, token)
}

export function removeToken (TokenKey) {
  return Cookies.remove(TokenKey)
}

export function getChannel () {
  let tokenValue = Cookies.get(channelTokenkey)
  return tokenValue || 'SAIC'
}

export function setChannel (token) {
  if (token === undefined || token === 'undefined') {
    return
  }
  if (token.match(/^[0-9]*[1-9][0-9]*$/i)) {
    token = 'lz' + token
  }
  return Cookies.set(channelTokenkey, token)
}
// export function getSource () {
//   return Cookies.get(sourceTokenkey)
// }

// export function setSource (token) {
//   return Cookies.set(sourceTokenkey, token)
// }

// export function getUserId () {
//   return Cookies.get(userIdTokenkey)
// }

export function setUserId (token) {
  return Cookies.set(userIdTokenkey, token)
}



// WEBPACK FOOTER //
// ./src/common/utils/cookieHandler.js